jQuery(function ($) {
    const Scripts = {
        varInit() {
            this.header = $(".header");
            this.document = $(document);
            this.body = $('body');
            this.navButton = $('.js-nav__toggle');
            this.nav = $('.js-nav');
            this.sended = false;
        },

        navInit() {
            this.navButton.on('click', function () {
                if (this.navButton.hasClass('_active')) {
                    this.navButton.removeClass('_active');
                    this.nav.removeClass('_active');
                    this.body.removeClass('_fixed');
                } else {
                    this.navButton.addClass('_active');
                    this.nav.addClass('_active');
                    this.body.addClass('_fixed');
                }
            }.bind(this));
        },

        slidersInit() {
            if($('.battlepath__places').length){
                const sliders = $('.battlepath__slider'),
                thumbs = $('.battlepath__pagination');
                sliders.each(function(index, slider) {
                    const battlepathThumbs = new Swiper(thumbs[index], {
                        spaceBetween: 2,
                        direction: 'vertical',
                        loop: false,
                        freeMode: true,
                        slidesPerView: 6
                    });
                    const battlepathMain = new Swiper(slider, {
                        spaceBetween: 20,
                        speed: 850,
                        effect: 'fade',
                        thumbs: {
                            swiper: battlepathThumbs
                        },
                        pagination: {
                            el: ".js-fragment",
                            type: "fraction",
                            renderFraction: function (currentClass, totalClass) {
                                return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>';
                            },
                        }
                    });

                    resizeSlider(battlepathMain);
                    window.addEventListener('resize', () => {
                        resizeSlider(battlepathMain);
                    });
                });
            }

            if($('.subdivisions__slider').length){
                const sliders = $('.subdivisions__slider'),
                prevArrows = $('.subdivisions__prev'),
                nextArrows = $('.subdivisions__next');
                sliders.each(function(index, slider) {
                    const subdivisionsSlider = new Swiper(slider, {
                        slidesPerView: 1,
                        spaceBetween: 8,
                        speed: 800,
                        navigation: {
                            nextEl: nextArrows[index],
                            prevEl: prevArrows[index],
                        },
                        breakpoints: {
                            1365: {
                                spaceBetween: 40,
                            }
                        }
                    })
                });
            }

            if($('.media__gallery').length){
                const sliders = $('.media__gallery');
                sliders.each(function(index, slider) {
                    const gallerySlider = new Swiper(slider, {
                        slidesPerView: 5,
                        spaceBetween: 8,
                        speed: 600,
                        loop: true,
                        initialSlide: 1,
                        centeredSlidesBounds: true,
                        centeredSlides: true,
                        centerInsufficientSlides: true,
                        autoplay: {
                            delay: 2000,
                        },
                        breakpoints: {
                            767: {
                                slidesPerView: 7,
                            },
                            1365: {
                                spaceBetween: 20,
                                slidesPerView: 6,
                            }
                        },
                    })
                });
            }

            function resizeSlider(slider) {
                const media_query = 'screen and (max-width:1365px)';
                const matched = window.matchMedia(media_query).matches;

                if (!matched) {
                    slider.enable();
                } else {
                    slider.disable();
                }
            }
        },

        scrollEventsInit() {
            const activeArea = $('.js-scroll-area'),
            header = this.header;
            let targetItems = [];

            function createIntervals() {
                targetItems = [];
                activeArea.each((_, container) => {
                    const items = $(container).find('.js-scroll-item');
                    items.each((_, item) => {
                        addInterval(item);
                    });
                });
            }

            function addInterval(item) {
                targetItems.push([
                    $(item).offset().top - window.innerHeight * .85,
                    $(item).offset().top + $(item).height(),
                    $(item),
                ]);
            }

            function handleScroll() {
                const offset = window.scrollY;

                targetItems.forEach((interval) => {
                    if (offset > interval[0]  && offset < interval[1]) {
                        const item = interval[2];
                        item.addClass('_visible')
                    }
                    else{
                        const item = interval[2];
                        item.removeClass('_visible')
                    }
                });

                if (offset > window.innerHeight*.4){
                    header.addClass('_fixed');
                }
                else{
                    header.removeClass('_fixed');
                }
            }

            createIntervals();
            handleScroll();

            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', () => setTimeout(createIntervals, 500));

            setTimeout(function(){
                window.dispatchEvent(new Event('resize'));
            }, 1500);


            if (typeof AOS !== 'undefined') {
                AOS.init({
                    offset: 80,
                    delay: 0,
                    duration: 900,
                    easing: 'ease',
                });
            }

        },

        contactFormUpdate() {
            const form = $('.wpcf7 form');
            if(form.length){
                const genderMore = $('.js-gender-more');
                const genderMoreWrap = genderMore.parent('.wpcf7-form-control-wrap');
                const genderOptions = $('.js-gender-options');
                const genderLast = genderOptions.find('.wpcf7-list-item.last label');
                if (genderMore && genderLast) {
                    genderLast.append(genderMore);
                    genderMore.after(genderMoreWrap);
                }

                const healthMore = $('.js-health-more');
                const healthMoreWrap = healthMore.parent('.wpcf7-form-control-wrap');
                const healthOptions = $('.js-health-options');
                const healthLast = healthOptions.find('.wpcf7-list-item.last label');
                if (healthMore && healthLast) {
                    healthLast.append(healthMore);
                    healthMore.after(healthMoreWrap);
                }
                const button = form.find('[type="submit"]');

                if (_OMBR && _OMBR.theme_url) {
                  const input = form.find('[name="user-phone"]');
                  form.append('<input type="hidden" name="user-phone-full"/>');
                  const iti = intlTelInput(input.get(0), {
                    initialCountry: 'ua',
                    onlyCountries: ['ua'],
                    countrySearch: false,
                    countrySelectorMode: "OFF",
                    showFlags: true,
                    separateDialCode: true,
                    numberDisplayFormat: "INTERNATIONAL",
                    strictMode: true,
                    loadUtils: () => import(_OMBR.theme_url + '/js/utils.js'),
                  });

                  input.on('blur', function () {
                    form.find('[name="user-phone-full"]').val(iti.getNumber());
                  });
                }
                form.find('[name="visitor"]').val(Scripts.visitor());

                form.on('submit', function() {
                    button.prop('disabled', 'disabled');
                });

                form.on('wpcf7beforesubmit', function(e) {
                  wpcf7.blocked = true;
                });

                form.on('wpcf7submit', function(e) {
                    button.prop('disabled', false);
                    wpcf7.blocked = false;
                    let detail;
                    if (e && e.originalEvent && e.originalEvent.detail) {
                        detail = e.originalEvent.detail;
                    }

                    if (detail && detail.apiResponse) {
                        if (! detail.apiResponse.invalid_fields || detail.apiResponse.invalid_fields.length == 0) {
                            form.trigger('reset');
                            Scripts.showSuccess(e);
                        }
                    }
                });

                form.on('wpcf7mailsent', function(e) {
                    form.trigger('reset');
                    Scripts.showSuccess(e);
                });
                form.on('wpcf7mailfailed', function(e) {
                    form.trigger('reset');
                    Scripts.showSuccess(e);
                });
            }

            MicroModal.init();
        },

        tabsInit() {
            $('.js-tabs-buttons').on('click', 'button', function (e) {
                e.preventDefault();

                const $btn   = $(this);
                const $wrap  = $btn.closest('.js-tabs-wrap');
                const index  = $btn.index() + 1; // nth-child — від 1

                $btn
                    .addClass('_active')
                    .siblings().removeClass('_active');

                $wrap.find('.js-tabs__item')
                    .removeClass('_active')
                    .filter(`:nth-child(${index})`)
                    .addClass('_active');
            });
        },

        copyButtonInit(){
            $('.js-copy-button').on('click', function(e){
                const button = $(this),
                container = button.parent('.js-copy'),
                valueElement = container.find('.js-copy-value'),
                value = valueElement.html().trim() || valueElement.val().trim();

                navigator.clipboard.writeText(value);

                $('<div class="js-copy-message" style="display:none">' + button.data('message').trim() + '</div>').appendTo(container).fadeIn(500, () => {
                    setTimeout(() => {
                        container.find('.js-copy-message').fadeOut(500, function remove() {
                            $(this).remove();
                        });
                    }, 800);
                });
            });
        },

        async paymentFormInit(){
            const form = $('.card__form form');

            function delay(callback, ms) {
                var timer = 0;
                return function() {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                    callback.apply(context, args);
                    }, ms || 0);
                };
            }

            async function updateSignature() {
                const data_field = form.find('[name="data"]'),
                    signature_field = form.find('[name="signature"]'),
                    formData = form.serialize();

                form.addClass('_loading');
                try {
                    const response = await $.ajax({
                        url: '/wp-json/custom/v1/card_form/',
                        type: 'POST',
                        data: {
                            action: 'handle_card_form_ajax',
                            form_data: formData
                        },
                    });
                    data_field.val(response.data);
                    signature_field.val(response.signature);
                }
                catch (error) {
                    console.error('Помилка при AJAX-запиті:', error);
                }
                finally {
                    form.removeClass('_loading');
                }
            }

            if(form.length){
                updateSignature();
            }

            $('.card__form form input:radio').on('change', async function() {
                await updateSignature();
            } );

            $('.card__form form input[type="number"]').on('keyup', delay(async function () {
                await updateSignature();
            }, 500));
        },

        initTel() {
            let tel=false;
            $('.j-tel').on('click', function () {
                tel = $(this).data('tel');
                if (Scripts.isMobile()) {
                    window.open('tel:' + tel);
                } else {
                    //MicroModal.show('mobile-popup');
                }
            });
        },

        isMobile() {
            if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
                return true;
            }
            if (navigator.maxTouchPoints > 0) {
                return true;
            }
            return false;
        },

        fp() {
          return md5([navigator.userAgent,[screen.height,screen.width,screen.colorDepth].join("x"),(new Date).getTimezoneOffset(),!!window.sessionStorage,!!window.localStorage,$.map(navigator.plugins,function(n){return[n.name,n.description,$.map(n,function(n){return[n.type,n.suffixes].join("~")}).join(",")].join("::")}).join(";")].join("###"));
        },

        visitor() {
          let name = 'visitor';
          let local = localStorage.getItem(name);
          let fp = Scripts.fp();

          if (local) {
            return local;
          }

          localStorage.setItem(name, fp);

          return fp;
        },

        initVacancies() {
          const $list = $('#j-vacancies-list');
          function renum() {
              let num = 1;
              $list.find('.j-number:visible').each(function () {
                $(this).text('[' + String(num).padStart(2, '0') + ']');
                num++;
              });
          }

          $('#j-vacancies').on('click', '.j-vacancy-filter', function (){
            const $el = $(this);
            $el.addClass('active').siblings().removeClass('active');
            const type = $el.data('slug');
            if (type) {
              $list.find('.j-vacancy').addClass('hide');
              $list.find('.j-vacancy[data-vacansy="' + type + '"]').removeClass('hide');
            } else {
              $list.find('.j-vacancy').removeClass('hide');
            }
            renum();
          });
        },

        initVacancy() {
          const $vacancy = $('#j-vacancy-section');
          if (! $vacancy.length) {
            return;
          }
          $vacancy.find('form [name="position"]').val($vacancy.find('.j-title').text().trim());
        },

        showSuccess(event) {
          if (! this.sended) {
            this.sended = true;
            window.dataLayer.push({
              "event" : "successfulSending",
              "formId" : event.detail.contactFormId,
              "response" : event.detail.inputs,
              "pluginVersion" : event.detail.pluginVersion,
              "containerPostId" : event.detail.containerPostId,
              "contactFormLocale" : event.detail.contactFormLocale,
              "unitTag" : event.detail.unitTag
            })
          }
          if ($('#success-popup').length) {
            MicroModal.show('success-popup');
          }
          const $vacancy = $('#j-vacancy-section');
          if (! $vacancy.length) {
            return;
          }
          $vacancy.find('.j-apply-form').addClass('hide');
          $vacancy.find('.j-success-message').removeClass('hide');
        },

        init() {
            Scripts.varInit();
            Scripts.navInit();
            Scripts.slidersInit();
            Scripts.scrollEventsInit();
            Scripts.contactFormUpdate();
            Scripts.tabsInit();
            Scripts.copyButtonInit();
            Scripts.paymentFormInit();
            Scripts.initTel();
            Scripts.initVacancies();
            Scripts.initVacancy();
        },
    };

    $(document).ready(function () {
        Scripts.init();
    });

});

/**
 * http://www.myersdaily.org/joseph/javascript/md5-text.html
 */
!function(n){var r=function(n,r){var t=n[0],c=n[1],i=n[2],a=n[3];t=o(t,c,i,a,r[0],7,-680876936),a=o(a,t,c,i,r[1],12,-389564586),i=o(i,a,t,c,r[2],17,606105819),c=o(c,i,a,t,r[3],22,-1044525330),t=o(t,c,i,a,r[4],7,-176418897),a=o(a,t,c,i,r[5],12,1200080426),i=o(i,a,t,c,r[6],17,-1473231341),c=o(c,i,a,t,r[7],22,-45705983),t=o(t,c,i,a,r[8],7,1770035416),a=o(a,t,c,i,r[9],12,-1958414417),i=o(i,a,t,c,r[10],17,-42063),c=o(c,i,a,t,r[11],22,-1990404162),t=o(t,c,i,a,r[12],7,1804603682),a=o(a,t,c,i,r[13],12,-40341101),i=o(i,a,t,c,r[14],17,-1502002290),c=o(c,i,a,t,r[15],22,1236535329),t=u(t,c,i,a,r[1],5,-165796510),a=u(a,t,c,i,r[6],9,-1069501632),i=u(i,a,t,c,r[11],14,643717713),c=u(c,i,a,t,r[0],20,-373897302),t=u(t,c,i,a,r[5],5,-701558691),a=u(a,t,c,i,r[10],9,38016083),i=u(i,a,t,c,r[15],14,-660478335),c=u(c,i,a,t,r[4],20,-405537848),t=u(t,c,i,a,r[9],5,568446438),a=u(a,t,c,i,r[14],9,-1019803690),i=u(i,a,t,c,r[3],14,-187363961),c=u(c,i,a,t,r[8],20,1163531501),t=u(t,c,i,a,r[13],5,-1444681467),a=u(a,t,c,i,r[2],9,-51403784),i=u(i,a,t,c,r[7],14,1735328473),c=u(c,i,a,t,r[12],20,-1926607734),t=e(t,c,i,a,r[5],4,-378558),a=e(a,t,c,i,r[8],11,-2022574463),i=e(i,a,t,c,r[11],16,1839030562),c=e(c,i,a,t,r[14],23,-35309556),t=e(t,c,i,a,r[1],4,-1530992060),a=e(a,t,c,i,r[4],11,1272893353),i=e(i,a,t,c,r[7],16,-155497632),c=e(c,i,a,t,r[10],23,-1094730640),t=e(t,c,i,a,r[13],4,681279174),a=e(a,t,c,i,r[0],11,-358537222),i=e(i,a,t,c,r[3],16,-722521979),c=e(c,i,a,t,r[6],23,76029189),t=e(t,c,i,a,r[9],4,-640364487),a=e(a,t,c,i,r[12],11,-421815835),i=e(i,a,t,c,r[15],16,530742520),c=e(c,i,a,t,r[2],23,-995338651),t=f(t,c,i,a,r[0],6,-198630844),a=f(a,t,c,i,r[7],10,1126891415),i=f(i,a,t,c,r[14],15,-1416354905),c=f(c,i,a,t,r[5],21,-57434055),t=f(t,c,i,a,r[12],6,1700485571),a=f(a,t,c,i,r[3],10,-1894986606),i=f(i,a,t,c,r[10],15,-1051523),c=f(c,i,a,t,r[1],21,-2054922799),t=f(t,c,i,a,r[8],6,1873313359),a=f(a,t,c,i,r[15],10,-30611744),i=f(i,a,t,c,r[6],15,-1560198380),c=f(c,i,a,t,r[13],21,1309151649),t=f(t,c,i,a,r[4],6,-145523070),a=f(a,t,c,i,r[11],10,-1120210379),i=f(i,a,t,c,r[2],15,718787259),c=f(c,i,a,t,r[9],21,-343485551),n[0]=l(t,n[0]),n[1]=l(c,n[1]),n[2]=l(i,n[2]),n[3]=l(a,n[3])},t=function(n,r,t,o,u,e){return r=l(l(r,n),l(o,e)),l(r<<u|r>>>32-u,t)},o=function(n,r,o,u,e,f,c){return t(r&o|~r&u,n,r,e,f,c)},u=function(n,r,o,u,e,f,c){return t(r&u|o&~u,n,r,e,f,c)},e=function(n,r,o,u,e,f,c){return t(r^o^u,n,r,e,f,c)},f=function(n,r,o,u,e,f,c){return t(o^(r|~u),n,r,e,f,c)},c=function(n){var t,o=n.length,u=[1732584193,-271733879,-1732584194,271733878];for(t=64;t<=n.length;t+=64)r(u,i(n.substring(t-64,t)));n=n.substring(t-64);var e=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(t=0;t<n.length;t++)e[t>>2]|=n.charCodeAt(t)<<(t%4<<3);if(e[t>>2]|=128<<(t%4<<3),t>55)for(r(u,e),t=0;16>t;t++)e[t]=0;return e[14]=8*o,r(u,e),u},i=function(n){var r,t=[];for(r=0;64>r;r+=4)t[r>>2]=n.charCodeAt(r)+(n.charCodeAt(r+1)<<8)+(n.charCodeAt(r+2)<<16)+(n.charCodeAt(r+3)<<24);return t},a="0123456789abcdef".split(""),d=function(n){for(var r="",t=0;4>t;t++)r+=a[n>>8*t+4&15]+a[n>>8*t&15];return r},h=function(n){for(var r=0;r<n.length;r++)n[r]=d(n[r]);return n.join("")},v=n.md5=function(n){return h(c(n))},l=function(n,r){return n+r&4294967295};if("5d41402abc4b2a76b9719d911017c592"!=v("hello"))var l=function(n,r){var t=(65535&n)+(65535&r),o=(n>>16)+(r>>16)+(t>>16);return o<<16|65535&t}}(window);
